import { ref } from "vue";
import { LOGIN_KEY } from "~/stores/translationBackends/HttpBackend";

// NR identity from the token handoff (display only — the token itself is
// read by HttpBackend/reviewStore when calling the API).
const login = ref<string | null>(null);
let initialized = false;

export function useIdentity() {
  if (!initialized && typeof localStorage !== "undefined") {
    login.value = localStorage.getItem(LOGIN_KEY);
    initialized = true;
  }
  return {
    login,
    refresh() {
      if (typeof localStorage !== "undefined") login.value = localStorage.getItem(LOGIN_KEY);
    },
  };
}
